export const SET_PROMO_LIST = '@promo/SET_PROMO_LIST';
export const SET_CODES_TO_REDUCER = '@promo/SET_CODES_TO_REDUCER';
export const OPEN_CODES_MODAL = '@promo/OPEN_CODES_MODAL';
export const OPEN_ACTIVATIONS_CODES_MODAL =
  '@promo/OPEN_ACTIVATIONS_CODES_MODAL';
export const SET_SELECTED_PROMO_ID = '@promo/SET_SELECTED_PROMO_ID';
